// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-row {
  width: 100%;
}
ion-row .flex-end {
  display: flex;
  justify-content: flex-end;
}

.button-small {
  font-weight: 700;
  font-size: 16px;
  height: 48px;
}

.withdraw-data ion-item {
  border: 1px solid #DDDDDD;
  border-radius: 4px;
  margin-bottom: 5px;
}

.text-bold {
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/cashier/withdraw/withdrawal-reverse/withdrawal-reverse.component.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;AACJ;AACI;EACI,aAAA;EACA,yBAAA;AACR;;AAGA;EACI,gBAAA;EACA,eAAA;EACA,YAAA;AAAJ;;AAII;EACI,yBAAA;EACA,kBAAA;EACA,kBAAA;AADR;;AAKA;EACI,iBAAA;AAFJ","sourcesContent":["ion-row {\r\n    width: 100%;\r\n\r\n    .flex-end {\r\n        display: flex;\r\n        justify-content: flex-end;\r\n    }\r\n}\r\n\r\n.button-small {\r\n    font-weight: 700;\r\n    font-size: 16px;\r\n    height: 48px;\r\n}\r\n\r\n.withdraw-data{\r\n    ion-item{\r\n        border: 1px solid #DDDDDD;\r\n        border-radius: 4px;\r\n        margin-bottom: 5px;\r\n    }\r\n}\r\n\r\n.text-bold{\r\n    font-weight: bold;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
